import {view} from '@sail/ui/deprecated';
import {MessageDescriptor} from 'react-intl';
import {ChatRow} from './ChatRow';
import {ChatSelectOptions, Option} from './ChatSelectOptions';

type Props = {
  label?: MessageDescriptor;
  options: Option[];
  selectedOption?: Option;
  onSelected: (option: Option) => void;
  error?: React.ReactNode;
  disabled?: boolean;
  submitting?: boolean;
};

export const ChatSelectOptionsRow = (props: Props): JSX.Element => {
  return (
    <view.div data-testid="chat-options-select-row">
      <ChatRow>
        <ChatSelectOptions {...props} />
      </ChatRow>
    </view.div>
  );
};
